import React, { useEffect, useState } from "react";
import { Button, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../../../../../assets/images/LanguageSelectorIconVideo.svg";
import { useFollowUp } from "providers/FollowUpProvider";
import { LIMITED_VIDEO_LANGUAGE_ACTIVITY_IDS } from "./VideoTaskList";

const VideoLanguage = ({ onVideoLanguageChange }) => {
  const { currentTask } = useFollowUp();
  const { t } = useTranslation();

  const showAllLanguages = !LIMITED_VIDEO_LANGUAGE_ACTIVITY_IDS.includes(currentTask.id);

  // Load from session or default to 'swedish'
  const [selectedLanguage, setSelectedLanguage] = useState(
    sessionStorage.getItem("selectedVideoLanguage") || "swedish",
  );

  useEffect(() => {
    sessionStorage.setItem("selectedVideoLanguage", selectedLanguage);
  }, [selectedLanguage]);

  const handleLanguageChange = value => {
    setSelectedLanguage(value);
    onVideoLanguageChange(value);
  };

  const extraLanguages = [
    { value: "arabic", label: t("Arabic_Lang") },
    { value: "danish", label: t("Danish_Lang") },
    { value: "german", label: t("German_Lang") },
    { value: "finnish", label: t("Finnish_Lang") },
    { value: "french", label: t("French_Lang") },
    { value: "italian", label: t("Italian_Lang") },
    { value: "norwegian", label: t("Norwegian_Lang") },
    { value: "lithuanian", label: t("Lithuanian_Lang") },
    { value: "polish", label: t("Polish_Lang") },
  ];

  return (
    <Menu closeOnSelect={true} placement="top-end">
      <MenuButton as={Button}>
        <Image src={LanguageSelect} alt="Select Language" />
      </MenuButton>
      <MenuList minWidth="100px" bgColor="darkPurple" borderColor="transparent">
        <MenuOptionGroup value={selectedLanguage} type="radio" onChange={handleLanguageChange}>
          <MenuItemOption value="swedish" bgColor="darkPurple">
            {t("Swedish_Lang")}
          </MenuItemOption>
          <MenuItemOption value="english" bgColor="darkPurple">
            {t("English_Lang")}
          </MenuItemOption>
          {showAllLanguages &&
            extraLanguages.map(lang => (
              <MenuItemOption key={lang.value} value={lang.value} bgColor="darkPurple">
                {lang.label}
              </MenuItemOption>
            ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};

export default VideoLanguage;
